module.exports = __webpack_public_path__ + "img/senderrand-runner-step-4.f773d0b8.svg";